import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'
// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import DropdownDepartments from '../Components/DropdownDepartments'
import DropdownCompanies from '../Components/DropdownCompanies'
import DropdownUsers from '../Components/DropdownUsers'
import DropdownRoles from '../Components/DropdownRoles'
import DropdownPositions from '../Components/DropdownPositions'
import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx'
import { insertOne, updateOne, retrieveUserInfo } from '../../services/generalServiceAPI'
import AppContext from '../../services/context'
import * as Utility from '../utility/utility'
import { isEmpty } from 'lodash'

import swal from 'sweetalert'
// const { userRoles, position } = GeneralData
// const userPositions = Utility.generateOptionsFromStringArray(position)

class UserProfile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        button: 'Create',
        title: 'Create Profile',
      },
      data: {
        tableName: 'users',
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        alternativeEmail: '',
        // telephone: '',
        // cell: '',
        password: '',
        confirmPassword: '',
        company: '',
        department: '',
        reportToId: '',
        roleID: 99,
        role: {
          value: 99,
          label: 'Guest',
        },
        // city: '',
        // country: '',
        // postalcode: '',
        // isOnVacation: false,
        weight: 0,
      },
      dataState: {
        usernameState: 'mandatory',
        firstnameState: 'mandatory',
        lastnameState: 'mandatory',
        emailState: 'mandatory',
        alternativeEmailState: '',
        // telephoneState: '',
        // cellState: '',
        passwordState: '',
        confirmPasswordState: '',
        companyState: '',
        departmentState: '',
        reportToIdState: '',
        roleState: '',
        // cityState: '',
        // countryState: '',
        // postalcodeState: '',
        // isOnVacationState: '',
        weightState: '',
      },
      isPasswordChanged: false,
      showConfirmedPassword: false,
      showPassword: false,
    }
    this.n = 0
    this.registerClick = this.registerClick.bind(this)
    this.change = this.change.bind(this)
    this.handleDropdown = this.handleDropdown.bind(this)
  }
  static contextType = AppContext

  isNotAllowToEdit = (login, profile) => login.roleID >= 2 || (login.roleID === 1 && login.company.id !== profile.company.id)
  handleClickShowPassword = (e) => {
    if (isEmpty(this.state.data.id) || this.state.data.id === this.context.user.id) this.setState((state) => ({ showPassword: !state.showPassword }))
  }
  handleClickShowConfirmedPassword = (e) => {
    if (isEmpty(this.state.data.id) || this.state.data.id === this.context.user.id)
      this.setState((state) => ({
        showConfirmedPassword: !state.showConfirmedPassword,
      }))
  }
  handleDropdown = (name, type, n) => (value) => {
    console.log(value)
    const { data, dataState } = this.state

    // assignment
    // handle dropdowns using non-system-assigned id, so the name need to follow xxxID
    // otherwise, the naming convention is xxxxId

    data[name] = value

    // inter-relationship of different dropdown ----> dependancy
    switch (name) {
      case 'company':
        data['department'] = {}
        data['reportTo'] = {}
        break
      case 'department':
        data['reportTo'] = {}
        break
      default:
    }
    //have name and id share the same name in state, the state for dropdown or required field
    // is set to 'error' initially
    dataState[name] = 'success'
    this.setState({
      data,
      dataState,
    })
  }
  change(event, stateName, type, stateNameEqualTo, maxValue) {
    // console.log(this.n++, this.state.data[stateName], event.target.value)

    /*
     1. disable the autofill function, it seems this can't be disabled in lastest broswer by using autoComplet='off'
     ** Side-effect: autofilled input will lose the helper label
     *** disable this since it also brings in the above side-effect, so just rurn off the endorsement to show the password
    */
    // if (this.state.data[stateName] === '' && event.target.value.length >= 2) return

    switch (type) {
      case 'email':
        if (Utility.verifyEmail(event.target.value)) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'password':
        if (Utility.verifyMinLength(event.target.value, 8)) {
          if (Utility.compare(event.target.value, this.state.data['confirmPassword'])) {
            this.setState({
              dataState: { ...this.state.dataState, [stateName + 'State']: 'success', confirmPasswordState: 'success' },
              isPasswordChanged: true,
            })
          } else {
            this.setState({
              dataState: { ...this.state.dataState, [stateName + 'State']: 'success', confirmPasswordState: 'error' },
              isPasswordChanged: true,
            })
          }
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'equalTo':
        if (Utility.compare(event.target.value, this.state.data[stateNameEqualTo])) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'checkbox':
        if (event.target.checked) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'number':
        if (Utility.verifyNumber(event.target.value)) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'length':
        if (Utility.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'max-length':
        if (Utility.verifyMaxLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'url':
        if (Utility.verifyUrl(event.target.value)) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'min-value':
        if (Utility.verifyNumber(event.target.value) && event.target.value >= stateNameEqualTo) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'max-value':
        if (Utility.verifyNumber(event.target.value) && event.target.value <= stateNameEqualTo) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      case 'range':
        if (Utility.verifyNumber(event.target.value) && event.target.value >= stateNameEqualTo && event.target.value <= maxValue) {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { ...this.state.dataState, [stateName + 'State']: 'error' } })
        }
        break
      default:
        break
    }
    switch (type) {
      case 'checkbox':
        this.setState({
          data: { ...this.state.data, [stateName]: event.target.checked },
        })
        break
      default:
        this.setState({
          data: { ...this.state.data, [stateName]: event.target.value },
        })
        break
    }
  }
  registerClick() {
    const { dataState: originalState, data } = this.state
    let newDataState = originalState
    if (data.username === '') {
      newDataState = { ...newDataState, usernameState: 'error' }
    }
    if (data.lastname === '') {
      newDataState = { ...newDataState, lastnameState: 'error' }
    }
    if (data.firstname === '') {
      newDataState = { ...newDataState, firstnameState: 'error' }
    }
    // if (data.company === '') {
    //   newDataState = { ...newDataState, companyState: 'error' }
    // }
    if (data.email === '') {
      newDataState = { ...newDataState, emailState: 'error' }
    }

    this.setState({ dataState: newDataState })
    if (Utility.noError(newDataState)) {
      const insertOrModify = (data) => (this.state.data.id ? updateOne(data) : insertOne(data))
      //remove confirmpassword
      const { password, confirmPassword, company, department, reportTo, role, position, weight, ...rest } = this.state.data
      //companyName, departmentName, reportToName, roleName
      // keep the above junk data till getUserInfo is able to fetch them dynamically

      // only save password when it's changed, otherwise it will override the existing one accidently

      let dataToSave = {
        ...rest,
        companyId: isEmpty(company) ? null : company.id,
        departmentId: isEmpty(department) ? null : department.id,
        reportToId: isEmpty(reportTo) ? null : reportTo.value,
        roleID: isEmpty(role) ? null : role.value,
        positionId: isEmpty(position) ? null : position.value,
        weight: parseInt(weight),
        tableName: 'users',
      }
      if (this.state.isPasswordChanged) {
        dataToSave = { ...dataToSave, password }
      }
      // console.log(this.state.isPasswordChanged)
      // console.log(dataToSave)
      insertOrModify(dataToSave)
        .then((response) => {
          if (response.ok) {
            return response.json()
          } else
            swal(response.url, {
              icon: 'error',
            })
        })
        .then((res) => {
          const recordId = res.id ? res.id : this.state.data.id
          swal('This record has beend saved - ' + recordId, {
            icon: 'success',
          })
          if (this.props.refetch) this.props.refetch()
          this.props.history.push('/administration/allusers')
          // following codes is made not to be reachable
          if (this.props.match.path === '/user/profile') {
            // if user has modified his own info, update context
            // this isn't gonna work, the user in context isn't loaded using graphQL
            // missing a lot info
            this.context.user = this.state.data
          }
          // update id in state.data for newly create user
          if (!this.state.data.id) {
            this.setState({
              data: {
                ...this.state.data,
                id: res.id,
              },
            })
          }
        })
        .catch((e) => swal(`apollo throw error: ${e}`))
    } else swal('Make sure all the mandatory fields are filled and all the inputs are legitimate.')
  }
  async componentDidMount() {
    try {
      // path such '/user/profile' will be triggered by user themselves
      // console.log(this.props.match)
      let user, text
      if (this.props.match.path === '/user/profile') {
        await retrieveUserInfo({ id: this.context.user.id }).then(({ data }) => {
          user = data.user
        })
        text = {
          button: 'Update',
          title: 'Update My Profile',
        }
      } else if (this.props.match.path === '/administration/updateuser') {
        // this handles the click from user table
        if (this.props.location.state) {
          text = {
            button: 'Update',
            title: 'Update Profile',
          }
          user = this.props.location.state
        }
      } else {
        // when chrome remember the user/pass, createuser will populate user/pass somehow
        user = {}
        text = {
          button: 'Create',
          title: 'Create Profile',
        }
      }
      Utility.logger(`[UserProfile][DidMount]: `, { user })
      if (!isEmpty(user)) {
        const { password, email, alternativeEmail, company, department, reportTo, role, position, ...others } = user
        this.setState({
          data: {
            ...this.state.data,
            ...others,
            confirmPassword: !password ? '' : password,
            email: !email ? '' : email,
            alternativeEmail: !alternativeEmail ? '' : alternativeEmail,
            company: !company ? '' : { id: company.id, label: company.name },
            department: !department ? '' : { id: department.id, label: department.name },
            reportTo: !reportTo ? {} : { value: reportTo.id, label: reportTo.name },
            role: !role ? '' : { value: role.id, label: role.name },
            position: !position ? '' : { value: position.id, label: position.name },
          },
          text,
          dataState: {
            usernameState: '',
            firstnameState: '',
            lastnameState: '',
            emailState: '',
          },
        })
      }
    } catch (e) {
      Utility.logger(`[UserProfile][DidMount]: `, { e }, true)
    }
  }
  render() {
    const { classes } = this.props

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.state.text.title}</h4>
              </CardHeader>
              <CardBody style={{ autoComplete: 'off' }}>
                {/* style={{ autocomplete: 'off', width: '100px' }} */}
                {/* autocomplete="off" width="200px" style={{ autoComplete: 'off' }} */}
                <form>
                  {/* <CustomInput
                    labelText="stupid-chrome"
                    id="stupid-chrome"
                    inputProps={{
                      type: 'hidden'
                    }}
                  /> */}
                  {/**  username and first and last name*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        success={this.state.dataState.usernameState === 'success'}
                        error={this.state.dataState.usernameState === 'error'}
                        labelText='Username'
                        id='username'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          // autoComplete: 'PleaseDoNot',
                          disabled: !isEmpty(this.state.data.id),
                          value: this.state.data.username,
                          onChange: (event) => this.change(event, 'username', 'max-length', 10),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText='First Name'
                        id='firstname'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        success={this.state.dataState.firstnameState === 'success'}
                        error={this.state.dataState.firstnameState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.firstname,
                          onChange: (event) => this.change(event, 'firstname', 'max-length', 50),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText='Last Name'
                        id='lastname'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        success={this.state.dataState.lastnameState === 'success'}
                        error={this.state.dataState.lastnameState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.lastname,
                          onChange: (event) => this.change(event, 'lastname', 'max-length', 50),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* emails*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText='Email address'
                        id='email'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        success={this.state.dataState.emailState === 'success'}
                        error={this.state.dataState.emailState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.email,
                          onChange: (event) => this.change(event, 'email', 'email'),
                          type: 'email',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText='Alternative Email address'
                        id='alternativeEmail'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        success={this.state.dataState.alternativeEmailState === 'success'}
                        error={this.state.dataState.alternativeEmailState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.alternativeEmail,
                          onChange: (event) => this.change(event, 'alternativeEmail', 'email'),
                          type: 'email',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* password line, only available for admins*/}
                  {this.context.user.roleID <= 1 ? (
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText='Password'
                          id='password'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          success={this.state.dataState.passwordState === 'success'}
                          error={this.state.dataState.passwordState === 'error'}
                          inputProps={{
                            disabled: false,
                            value: this.state.data.password,
                            onChange: (event) => this.change(event, 'password', 'password'),
                            type: this.state.showPassword ? 'text' : 'password',
                            // autoComplete: 'off', // this is the right syntax to enable it - Capital "C", but it doesn't work
                            // endAdornment: (
                            //   <InputAdornment position="end">
                            //     <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                            //       {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                            //     </IconButton>
                            //   </InputAdornment>
                            // )
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText='Comfirm Password'
                          id='confirmPassword'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          success={this.state.dataState.confirmPasswordState === 'success'}
                          error={this.state.dataState.confirmPasswordState === 'error'}
                          inputProps={{
                            disabled: false,
                            value: this.state.data.confirmPassword,
                            onChange: (event) => this.change(event, 'confirmPassword', 'equalTo', 'password'),
                            type: this.state.showConfirmedPassword ? 'text' : 'password',
                            // endAdornment: (
                            //   <InputAdornment position="end">
                            //     <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowConfirmedPassword}>
                            //       {this.state.showConfirmedPassword ? <VisibilityOff /> : <Visibility />}
                            //     </IconButton>
                            //   </InputAdornment>
                            // )
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                  ) : (
                    ''
                  )}
                  {/* company, department and role*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownCompanies
                        id='company'
                        isDisabled={this.isNotAllowToEdit(this.context.user, this.state)}
                        onChange={this.handleDropdown('company')}
                        loose
                        value={this.state.data.company ? this.state.data.company.label : ''}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownDepartments
                        id='department'
                        isDisabled={this.isNotAllowToEdit(this.context.user, this.state)}
                        onChange={this.handleDropdown('department')}
                        companyId={this.state.data.company.id}
                        loose
                        value={this.state.data.department ? this.state.data.department.label : ''}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownUsers
                        id='reportTo'
                        isDisabled={this.isNotAllowToEdit(this.context.user, this.state)}
                        onChange={this.handleDropdown('reportTo')}
                        // departmentId={this.state.data.department.id}
                        // companyId={this.state.data.company.id}
                        loose
                        helperText={'Choose the manager ...'}
                        value={this.state.data.reportTo ? this.state.data.reportTo.label : {}}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* director,role*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownRoles
                        id='role'
                        isDisabled={this.isNotAllowToEdit(this.context.user, this.state)}
                        onChange={this.handleDropdown('role')}
                        loose
                        value={this.state.data.role ? this.state.data.role.label : ''}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownPositions
                        id='positionId'
                        isDisabled={this.isNotAllowToEdit(this.context.user, this.state)}
                        onChange={this.handleDropdown('position')}
                        companyId={this.state.data.companyId}
                        loose
                        value={this.state.data.position ? this.state.data.position.label : ''}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText='Number of Signing nodes (BTA/TOA only)'
                        id='weight'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        success={this.state.dataState.weightState === 'success'}
                        error={this.state.dataState.weightState === 'error'}
                        inputProps={{
                          disabled: this.isNotAllowToEdit(this.context.user, this.state),
                          value: this.state.data.weight,
                          onChange: (event) => this.change(event, 'weight', 'maxValue', 100),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} />
                  </GridContainer>

                  {/* abot me*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel style={{ color: '#AAAAAA' }}>About me</InputLabel>
                      <CustomInput
                        labelText=''
                        id='about-me'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: !this.state.data.description ? '' : this.state.data.description,
                          onChange: (event) => this.change(event, 'description', 'max-length', 500),
                          multiline: true,
                          rows: 5,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <Button color='rose' className={classes.updateProfileButton} onClick={this.registerClick}>
                    {this.state.text.button}
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {Utility.jsonPP(this.state)}
      </div>
    )
  }
}

export default withStyles(userProfileStyles)(UserProfile)
// {Utility.jsonPP(this.state.data)}
// {Utility.jsonPP(this.state.dataState)}
